<template>
  <div class="favorites-page">
    <div class="favorites-container">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading...</p>
      </div>
      
      <!-- 收藏产品列表 -->
      <section v-else-if="favoriteProducts.length > 0" class="dFKDPr">
        <div v-for="product in favoriteProducts" :key="product.id" @click.prevent="goToProduct(product.id)" class="brdgFr">
          <div class="jdDQPU">
            <div class="ckFqou">
              <span class="hRjJTi"></span>
              <section class="hfBdmA NinWN" @click.stop.prevent="removeFavorite(product.id)">
                <svg class="kOIKqN yEigr" xmlns="http://www.w3.org/2000/svg" viewBox="18 18 60 60" width="24px" height="24px" style="fill: #000;">
                  <g>
                    <path
                      d="M48,71.6c-0.5,0-1-0.2-1.4-0.6L27.5,52.5c-0.2-0.2-0.5-0.4-0.8-0.8c-0.4-0.4-0.9-1-1.7-2   c-0.8-1-1.5-2-2.1-3c-0.6-1-1.2-2.3-1.6-3.7c-0.5-1.5-0.7-2.9-0.7-4.2c0-4.5,1.3-8,3.9-10.6s6.2-3.8,10.8-3.8   c1.3,0,2.6,0.2,3.9,0.7c1.3,0.4,2.5,1,3.7,1.8c1.1,0.7,2.1,1.4,2.9,2.1c0.8,0.7,1.6,1.4,2.3,2.1c0.7-0.7,1.5-1.4,2.3-2.1   c0.8-0.7,1.8-1.4,2.9-2.1c1.1-0.7,2.4-1.3,3.7-1.8c1.3-0.4,2.6-0.7,3.9-0.7c4.6,0,8.2,1.3,10.8,3.8s3.9,6.1,3.9,10.6   c0,4.5-2.3,9.1-7,13.8L49.4,71C49,71.4,48.5,71.6,48,71.6z">
                    </path>
                  </g>
                </svg>
              </section>
            </div>
            <a class="hVuiL" href="javascript:void(0)">
              <div class="bIDLrN">
                <img class="ccbPwe" :alt="product.title" :src="product.image" @error="handleImageError" />
              </div>
              <section class="krDmCz">
                <div class="kiJwvD row"></div>
                <div class="kiJwvD row">
                  <div class="feovUU col-xs-12">
                    <span class="title alZOz">{{ product.title }}</span>
                  </div>
                </div>
                <div class="kiJwvD row">
                  <div style="display: flex; flex-direction: column;width: 100%;">
                    <div class="feovUU">
                      <div>
                        <span class="kESQKC">
                          <span class="price">${{ product.currentPrice.toFixed(2) }}</span>
                        </span>
                        <span class="jPijkz">${{ product.originalPrice.toFixed(2) }}</span>
                      </div>
                    </div>
                    <div class="feovUU">
                      <section class="sc-kgoBCf cTjZbH">
                        <i v-for="i in 5" :key="i" :name="i <= product.rating ? 'star' : 'star-o'" 
                           :class="['fa', i <= product.rating ? 'fa-star' : 'fa-star-o']"
                           style="color: rgb(0, 0, 0); font-size: 11px; margin-right: 0px;"></i>
                      </section>
                      <section v-if="product.isPrime" class="lbhUOd">
                        <svg class="cSPCYd" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                          <g transform="translate(-1577.9 -248.353)">
                            <g>
                              <rect height="24" rx="11.729" transform="translate(1577.9 248.353)" width="24"></rect>
                            </g>
                            <g>
                              <path
                                d="M1587.662,264.374l-3.08-3.2a.59.59,0,0,1,.85-.818l2.255,2.344,6.688-6.533a.589.589,0,1,1,.824.843Z"
                                fill="#f2f2f2"></path>
                            </g>
                          </g>
                        </svg>
                        <span> prime</span>
                      </section>
                    </div>
                  </div>
                </div>
                <div class="kPWsBt">
                  <div class="fLIRzu">{{ product.discount }}% off</div>
                  <div class="fLIRzu">{{ product.daysLeft }} left</div>
                  <div class="fLIRzu">{{ product.stock }} clicks</div>
                </div>
              </section>
            </a>
          </div>
        </div>
      </section>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
        <h2>No favorites yet</h2>
        <p>Browse products and click the heart icon to save your favorites</p>
        <button class="btn-browse" @click="goToHome">Browse Products</button>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi } from '@/api'
import userStore from '@/store/user.js'

export default {
  name: 'Favorites',
  data() {
    return {
      userStore: userStore.state,
      loading: false,
      favoriteProducts: []
    }
  },
  async mounted() {
    // 检查登录状态
    userStore.checkAuth()
    
    if (!this.userStore.isLoggedIn) {
      this.$toast('Please log in first')
      this.$router.push('/').catch(() => {})
      return
    }
    
    await this.loadFavorites()
  },
  methods: {
    async loadFavorites() {
      try {
        this.loading = true
        const response = await productApi.getCollectList()
        
        console.log('收藏列表响应:', response)
        
        if (response.code === 1 && response.data) {
          this.favoriteProducts = response.data.map(item => {
            // 处理图片路径
            const imageUrl = item.image.startsWith('http') 
              ? item.image 
              : `https://houtai5698.koiodeal.com${item.image}`
            
            // 解析折扣率（去掉 % 符号）
            const discountValue = item.discount ? parseInt(item.discount.replace('%', '')) : 0
            
            return {
              id: item.id,
              title: item.title,
              image: imageUrl,
              currentPrice: parseFloat(item.price || 0),
              originalPrice: parseFloat(item.originprice || 0),
              discount: discountValue,
              daysLeft: item.etime || '0 days',
              stock: item.stock || 0,
              isPrime: item.primeswitch === 1,
              rating: 5 // 默认5星，接口未返回评分
            }
          })
          
          console.log('处理后的收藏列表:', this.favoriteProducts)
        }
      } catch (error) {
        console.error('Failed to load favorites:', error)
      } finally {
        this.loading = false
      }
    },
    async removeFavorite(productId) {
      try {
        const response = await productApi.setCollect(productId)
        
        if (response.code === 1) {
          // 取消收藏成功，从列表中移除
          const index = this.favoriteProducts.findIndex(p => p.id === productId)
          if (index > -1) {
            this.favoriteProducts.splice(index, 1)
          }
          console.log('取消收藏成功')
        } else {
          this.$toast(response.msg || 'Operation failed', 3000)
        }
      } catch (error) {
        console.error('Failed to remove favorite:', error)
        this.$toast('Operation failed, please try again', 3000)
      }
    },
    goToProduct(productId) {
      this.$router.push(`/productDetail/${productId}`).catch(() => {})
    },
    goToHome() {
      this.$router.push('/').catch(() => {})
    },
    handleImageError(e) {
      e.target.src = 'https://via.placeholder.com/280x250?text=Product+Image'
    }
  }
}
</script>

<style scoped>
.favorites-page {
  min-height: 100vh;
  /* background: #f5f5f5; */
  /* padding-top: 80px; */
}

.favorites-container {
  max-width: 1700px;
  width: 92%;
  margin: 0 auto;
  padding: 30px 0;
}

.page-header {
  background: white;
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.page-header h1 {
  margin: 0 0 5px 0;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.favorites-count {
  margin: 0;
  font-size: 14px;
  color: #666;
}

/* 收藏按钮样式 - 已收藏状态 */
.hfBdmA.NinWN {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.hfBdmA.NinWN:hover {
  transform: scale(1.1);
}

.hfBdmA.NinWN:active {
  transform: scale(0.95);
}

.kOIKqN.yEigr {
  transition: all 0.2s ease;
}

.hfBdmA.NinWN:hover .kOIKqN.yEigr {
  opacity: 0.8;
}

/* 空状态 */
.empty-state {
  background: white;
  padding: 80px 40px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* 加载状态 */
.loading-state {
  background: white;
  padding: 80px 40px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffc200;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.empty-state svg {
  color: #ddd;
  margin-bottom: 20px;
}

.empty-state h2 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}

.empty-state p {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #666;
}

.btn-browse {
  padding: 14px 40px;
  background: #ffc200;
  color: #000;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-browse:hover {
  background: #ffb300;
}

/* 移动端适配 */
@media (max-width: 1366px) {
  .favorites-container {
    width: 94%;
  }
}

@media (max-width: 767px) {
  .favorites-page {
    /* padding-top: 60px; */
  }

  .favorites-container {
    padding: 15px 0;
    width: 100%;
  }

  .page-header {
    padding: 20px 15px;
    margin-bottom: 20px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .page-header h1 {
    font-size: 22px;
  }

  .favorites-count {
    font-size: 13px;
  }

  .empty-state {
    padding: 60px 20px;
    margin: 0 15px;
  }

  .empty-state svg {
    width: 60px;
    height: 60px;
  }

  .empty-state h2 {
    font-size: 20px;
  }

  .empty-state p {
    font-size: 14px;
    margin-bottom: 25px;
  }

  .btn-browse {
    padding: 12px 30px;
    font-size: 14px;
  }
}
</style>
